import React from 'react';
import './Plasticmachiner.css';


const Plasticmachiner = () => {
    return (
        <div className="Plasticmach-container">
            <div className='Plasticmach'>
                <h4 className="Plasticmach-title">WHO ARE WE</h4>
                <p className="Plasticmach-date">Disha Technologies Ltd.
                    focus on developing and manufacturing injection molding machines
                    and extrusion blow molding machines and extended solutions since 2000.
                    Over 20,000 sets injection molding machines and extrusion
                    blow molding machines are installed world-wide by the team,
                    same as recognized by “Energy-saving, high-performance,
                    high-speed and precision”, which data keep updating. Our global
                    sales team and agency are dedicated to offfer pre-sales, after-sales, constaltant, tech-support
                    and maintenance service to fulfill customers’ requirements.</p>
                
            </div>
        </div>
    );
};
export default Plasticmachiner;
